module.exports = "/_next/static/images/8f60e1be109ce1e4588e23caa3afc0ad-comunidad-nu-lg.jpg.webp";